<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col md="12">
                <b-card>
                    <div slot="header">
                        <b-row>
                            <b-col md="4" class="text-start">
                                <strong>Destination Master</strong>
                            </b-col>
                            <b-col md="8" class="text-right">
                                <a :href="csvurl" target="_blank">
                                    <b-button variant="primary" size="sm" @click="downloadcsv()">
                                        <i class="fa fa-download"></i> Download Destination Master
                                    </b-button>
                                </a>&nbsp;
                                <b-button variant="primary" size="sm" @click="adddestination()"><i class="fa fa-plus" aria-hidden="true"></i>
                                    Add Destination 
                                </b-button>&nbsp;
                                <b-button variant="primary" size="sm" @click="search()"><i class="fa fa-search" aria-hidden="true"></i> Search</b-button>&nbsp;
                                <b-button variant="primary" size="sm" @click="clear()"><i class="fa fa-search"></i> Reset Search Filter</b-button>
                            </b-col>
                        </b-row>
                    </div>

                    <div v-if="add_destinationinfo">
                        <div>
  
                            <h4>Add Destination Master</h4>
                            <hr>
                            <b-form
                            @submit.prevent="validateForm('form-3')"
                            data-vv-scope="form-3">
                                <div class="row mt-3">
                                    <div class="col-md-4">
                                        <b-form-group>
                                            <label><b>Client Name</b> <span style="color:red;"> *</span></label>
                                            <v-select name="destination ClientName" v-model="customer.destinationClientName" :options="clientname" placeholder="select destination Client Name" v-validate="'required'"
                                                :class="{ input: true, 'is-invalid': errors.has('form-3.destination ClientName'),
                                                }"></v-select>
                                            <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i
                                                    class="fa fa-warning"
                                                    v-show="errors.has('destination ClientName')"
                                                ></i>
                                                </span>
                                                <span
                                                style="width:240px"
                                                v-show="errors.has('form-3.destination ClientName')"
                                                class="help text-danger"
                                                >{{ errors.first("form-3.destination ClientName") }}</span
                                                >
                                            </b-input-group>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-4">
                                        <b-form-group>
                                            <label><b>Destination Type</b> <span style="color:red;"> *</span></label>
                                            <v-select  name="destinationtype" v-model="customer.destination_type" :options="desti_type" v-validate="'required'"
                                            :class="{ input: true, 'is-invalid': errors.has('form-3.destinationtype'),
                                            }" placeholder="select destination type"></v-select>
                                            <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i
                                                    class="fa fa-warning"
                                                    v-show="errors.has('destinationtype')"
                                                ></i>
                                                </span>
                                                <span
                                                style="width:240px"
                                                v-show="errors.has('form-3.destinationtype')"
                                                class="help text-danger"
                                                >{{ errors.first("form-3.destinationtype") }}</span
                                                >
                                            </b-input-group>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-4">
                                        <b-form-group>
                                            <label><b>Destination Name</b> <span style="color:red;"> *</span></label>
                                            <b-input-group>
                                                <b-form-input type="text" name="destinationName" v-model.trim="customer.destinationName" placeholder="Destination Name" class="italic-placeholder" v-validate="'required'"
                                                :class="{ input: true, 'is-invalid': errors.has('form-3.destinationName'),
                                                }"></b-form-input>
                                            </b-input-group>
                                            <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i
                                                    class="fa fa-warning"
                                                    v-show="errors.has('destinationName')"
                                                ></i>
                                                </span>
                                                <span
                                                style="width:240px"
                                                v-show="errors.has('form-3.destinationName')"
                                                class="help text-danger"
                                                >{{ errors.first("form-3.destinationName") }}</span
                                                >
                                            </b-input-group>
                                        </b-form-group>
                                    </div>
                                    <!-- ~~~~~~~~~~~~~~ -->
                                    <div class="col-md-4">
                                        <b-form-group>
                                            <label><b>Destination ID</b> <span style="color:red;"> *</span></label>
                                            <b-input-group>
                                                <b-form-input type="text" name="destinationId" v-model.trim="customer.destinationId" placeholder="Destination ID" class="italic-placeholder" v-validate="'required'"
                                                :class="{ input: true, 'is-invalid': errors.has('form-3.destinationId'),
                                                }"></b-form-input>
                                            </b-input-group>
                                            <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i
                                                    class="fa fa-warning"
                                                    v-show="errors.has('destinationId')"
                                                ></i>
                                                </span>
                                                <span
                                                style="width:240px"
                                                v-show="errors.has('form-3.destinationId')"
                                                class="help text-danger"
                                                >{{ errors.first("form-3.destinationId") }}</span
                                                >
                                            </b-input-group>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-4">
                                        <b-form-group>
                                            <label><b>Country Name</b> <span style="color:red;"> *</span></label>
                                            <v-select  name="Destination Country" v-model="customer.destinationCountry" :options="country" @input="selectcountry('country',customer.destinationCountry)" v-validate="'required'"
                                            :class="{ input: true, 'is-invalid': errors.has('form-3.Destination Country'),
                                            }" placeholder="select destination type"></v-select>
                                            <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i
                                                    class="fa fa-warning"
                                                    v-show="errors.has('Destination Country')"
                                                ></i>
                                                </span>
                                                <span
                                                style="width:240px"
                                                v-show="errors.has('form-3.Destination Country')"
                                                class="help text-danger"
                                                >{{ errors.first("form-3.Destination Country") }}</span
                                                >
                                            </b-input-group>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-4">
                                        <b-form-group>
                                            <label><b>State Name</b> <span style="color:red;"> *</span></label>
                                            <v-select  name="Destination State"  placeholder=" Select Destination State" v-model="customer.destinationState" @input="selectstate('city',customer.destinationCountry,customer.destinationState)" :disabled="!customer.destinationCountry"  :options="StateList" v-validate="'required'"
                                            :class="{ input: true, 'is-invalid': errors.has('form-3.Destination State'),
                                            }"></v-select>
                                            <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i
                                                    class="fa fa-warning"
                                                    v-show="errors.has('Destination State')"
                                                ></i>
                                                </span>
                                                <span
                                                style="width:240px"
                                                v-show="errors.has('form-3.Destination State')"
                                                class="help text-danger"
                                                >{{ errors.first("form-3.Destination State") }}</span
                                                >
                                            </b-input-group>
                                        </b-form-group>
                                    </div>
                    
                                    <!-- ~~~~~~~~~~~~~~ -->        
                                    <div class="col-md-4">
                                        <!-- <b-form-group>
                                            <label><b>City Name</b> <span style="color:red;"> *</span></label>
                                            <b-input-group>
                                                <b-form-input name="destinationCity"  placeholder="Destination City" v-model="customer.destinationCity" v-validate="'required|alpha_spaces'"
                                                :class="{ input: true, 'is-invalid': errors.has('form-3.destinationCity'),
                                                }"></b-form-input>
                                            </b-input-group>
                                            <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i
                                                    class="fa fa-warning"
                                                    v-show="errors.has('destinationCity')"
                                                ></i>
                                                </span>
                                                <span
                                                style="width:240px"
                                                v-show="errors.has('form-3.destinationCity')"
                                                class="help text-danger"
                                                >{{ errors.first("form-3.destinationCity") }}</span
                                                >
                                            </b-input-group>
                                        </b-form-group> -->

                                        <b-form-group>
                                            <label><b>City Name</b> <span style="color:red;"> *</span></label>
                                            <v-select name="Destination City"       @input="selectcity('pincode',customer.destinationCountry,customer.destinationState,customer.destinationCity)" :disabled="!customer.destinationState" placeholder="Select City Name" :options="CityList"  v-model="customer.destinationCity" v-validate="'required'"
                                            :class="{ input: true, 'is-invalid': errors.has('form-3.Destination City'),
                                            }"></v-select>
                                            <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i
                                                    class="fa fa-warning"
                                                    v-show="errors.has('Destination City')"
                                                ></i>
                                                </span>
                                                <span
                                                style="width:240px"
                                                v-show="errors.has('form-3.Destination City')"
                                                class="help text-danger"
                                                >{{ errors.first("form-3.Destination City") }}</span
                                                >
                                            </b-input-group>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-4">
                                        <b-form-group>
                                            <label><b>Destination Pincode</b> <span style="color:red;"> *</span></label>
                                            <v-select  name="Destination Pincode"       :disabled="!customer.destinationCity" :options="PincodeList" v-model="customer.destinationPincode" placeholder=" Select Destination Pincode" class="italic-placeholder" v-validate="'required'"
                                            :class="{ input: true, 'is-invalid': errors.has('form-3.Destination Pincode'),
                                            }"></v-select>
                                            <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i
                                                    class="fa fa-warning"
                                                    v-show="errors.has('Destination Pincode')"
                                                ></i>
                                                </span>
                                                <span
                                                style="width:240px"
                                                v-show="errors.has('form-3.Destination Pincode')"
                                                class="help text-danger"
                                                >{{ errors.first("form-3.Destination Pincode") }}</span
                                                >
                                            </b-input-group>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-4">
                                        <b-form-group>
                                            <label><b>Destination Address</b> <span style="color:red;"> *</span></label>
                                            <b-input-group>
                                                <b-form-input type="text" name="destinationAddress" v-model.trim="customer.destinationAddress" placeholder="Destination Address" class="italic-placeholder" v-validate="'required'"
                                                :class="{ input: true, 'is-invalid': errors.has('form-3.destinationAddress'),
                                                }"></b-form-input>
                                            </b-input-group>
                                            <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i
                                                    class="fa fa-warning"
                                                    v-show="errors.has('destinationAddress')"
                                                ></i>
                                                </span>
                                                <span
                                                style="width:240px"
                                                v-show="errors.has('form-3.destinationAddress')"
                                                class="help text-danger"
                                                >{{ errors.first("form-3.destinationAddress") }}</span
                                                >
                                            </b-input-group>
                                        </b-form-group>
                                    </div>
                                    <!-- ~~~~~~~~~~~~~~ -->        
                                    <div class="col-md-4">
                                        <b-form-group>
                                            <label><b>Select Constraint</b> <span style="color:red;"> *</span></label>
                                            <ejs-multiselect id='multiselect' :dataSource='constrainlist' placeholder="Select Constraint" mode="CheckBox" :fields='fields1' v-model="customer.destinationconstraint_id" 
                                            name="Constraint" v-validate="'required'"
                                            :class="{ input: true, 'is-invalid': errors.has('form-3.Constraint'),
                                            }" @change="handleConstrainName"></ejs-multiselect>
                                            <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i
                                                    class="fa fa-warning"
                                                    v-show="errors.has('Constraint')"
                                                ></i>
                                                </span>
                                                <span
                                                style="width:240px"
                                                v-show="errors.has('form-3.Constraint')"
                                                class="help text-danger"
                                                >{{ errors.first("form-3.Constraint") }}</span
                                                >
                                            </b-input-group>
                                        </b-form-group>
                                    </div>

                                    <div class="col-md-4" v-if="constraintName === 'Vehicle Size'" v-for="constraintName in checkconstraintnames" :key="constraintName">
                                        <!-- <b-form-group>
                                            <label><b>Restricted Vehicle Size</b> <span style="color:red;"> *</span></label>
                                            <v-select :options="restrictvehicledata" v-model="customer.vehicle_size" placeholder="Select Restricted Vehicle Size"  name="Restricted Vehicle Size" v-validate="'required'"
                                            :class="{ input: true, 'is-invalid': errors.has('form-3.destinationPoc'),
                                            }"></v-select>
                                            <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i
                                                    class="fa fa-warning"
                                                    v-show="errors.has('Restricted Vehicle Size')"
                                                ></i>
                                                </span>
                                                <span
                                                style="width:240px"
                                                v-show="errors.has('form-3.Restricted Vehicle Size')"
                                                class="help text-danger"
                                                >{{ errors.first("form-3.Restricted Vehicle Size") }}</span
                                                >
                                            </b-input-group>
                                        </b-form-group> -->
                                       
                                        <b-form-group>
                                            <label><b>Restricted Vehicle Size</b> <span style="color:red;"> *</span></label>
                                            <ejs-multiselect
                                              :dataSource='restrictvehicledata'
                                              placeholder="Select Restricted Vehicle Size"
                                              mode="CheckBox" id='multiselect' 
                                              v-model="customer.vehicle_size"
                                              name="Restricted Vehicle Size"
                                              v-validate="'required'"
                                              :class="{ input: true, 'is-invalid': errors.has('form-3.Restricted Vehicle Size') }"
                                            ></ejs-multiselect>
                                            <b-input-group class="mb-3">
                                              <span class="icon has-text-warning">
                                                <i class="fa fa-warning" v-show="errors.has('Restricted Vehicle Size')"></i>
                                              </span>
                                              <span style="width:240px" v-show="errors.has('form-3.Restricted Vehicle Size')" class="help text-danger">
                                                {{ errors.first("form-3.Restricted Vehicle Size") }}
                                              </span>
                                            </b-input-group>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-4" v-if="constraintName === 'Fuel Type'" v-for="constraintName in checkconstraintnames" :key="constraintName">
                                        <!-- <b-form-group>
                                            <label><b>Restricted Vehicle Fuel Type</b> <span style="color:red;"> *</span></label>
                                            <v-select :options="restrictvehicletype" v-model="customer.fuel_type" placeholder="Select Restricted Vehicle Fuel Type"  name="Restricted Vehicle Fuel Type" v-validate="'required'"
                                            :class="{ input: true, 'is-invalid': errors.has('form-3.destinationPoc'),
                                            }"></v-select>
                                            <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i
                                                    class="fa fa-warning"
                                                    v-show="errors.has('Restricted Vehicle Fuel Type')"
                                                ></i>
                                                </span>
                                                <span
                                                style="width:240px"
                                                v-show="errors.has('form-3.Restricted Vehicle Fuel Type')"
                                                class="help text-danger"
                                                >{{ errors.first("form-3.Restricted Vehicle Fuel Type") }}</span
                                                >
                                            </b-input-group>
                                        </b-form-group> -->
                                        <b-form-group>
                                            <label><b>Restricted Vehicle Fuel Type</b> <span style="color:red;"> *</span></label>
                                            <ejs-multiselect id='multiselect' :dataSource='restrictvehicletype' placeholder="Select Restricted Vehicle Fuel Type" mode="CheckBox" v-model="customer.fuel_type" 
                                            name="Restricted Vehicle Fuel Type" v-validate="'required'"
                                            :class="{ input: true, 'is-invalid': errors.has('form-3.Restricted Vehicle Fuel Type'),
                                            }"></ejs-multiselect>
                                            <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i
                                                    class="fa fa-warning"
                                                    v-show="errors.has('Restricted Vehicle Fuel Type')"
                                                ></i>
                                                </span>
                                                <span
                                                style="width:240px"
                                                v-show="errors.has('form-3.Restricted Vehicle Fuel Type')"
                                                class="help text-danger"
                                                >{{ errors.first("form-3.Restricted Vehicle Fuel Type") }}</span
                                                >
                                            </b-input-group>
                                        </b-form-group>
                                    </div>

                                    <div class="col-md-4" v-if="constraintName === 'Vehicle Restriction Time'" v-for="constraintName in checkconstraintnames" :key="constraintName">
                                        <b-form-group>
                                            <!-- @input="formatTime" -->
                                            <label><b>Vehicle Restriction time</b> <span style="color:red;"> *</span></label>
                                            <div class="input-group">
                                                <b>From : </b>
                                                <input v-model="customer.vehicle_restriction_time" class="form-control" type="time" id="startTime" name="Vehicle Restriction from time" v-validate="'required'"
                                                :class="{ input: true, 'is-invalid': errors.has('form-3.Vehicle Restriction from time'),
                                                }">
                                                <b-input-group class="mb-3">
                                                    <span class="icon has-text-warning">
                                                    <i
                                                        class="fa fa-warning"
                                                        v-show="errors.has('Vehicle Restriction from time')"
                                                    ></i>
                                                    </span>
                                                    <span
                                                    style="width:240px"
                                                    v-show="errors.has('form-3.Vehicle Restriction from time')"
                                                    class="help text-danger"
                                                    >{{ errors.first("form-3.Vehicle Restriction from time") }}</span
                                                    >
                                                </b-input-group>
                                            </div>
                                        </b-form-group>
                                    </div>

                                    <div class="col-md-4" v-if="constraintName === 'Vehicle Restriction Time'" v-for="constraintName in checkconstraintnames" :key="constraintName">
                                        <b-form-group>
                                            <!-- @input="formatTime" -->
                                            <label><b>Vehicle Restriction time</b> <span style="color:red;"> *</span></label>
                                            <div class="input-group">
                                                <b>To : </b>
                                                <input v-model="customer.vehicle_restriction_to_time" class="form-control" type="time"  name="Vehicle Restriction to time" v-validate="'required'"
                                                :class="{ input: true, 'is-invalid': errors.has('form-3.Vehicle Restriction to time'),
                                                }">
                                                <b-input-group class="mb-3">
                                                    <span class="icon has-text-warning">
                                                    <i
                                                        class="fa fa-warning"
                                                        v-show="errors.has('Vehicle Restriction to time')"
                                                    ></i>
                                                    </span>
                                                    <span
                                                    style="width:240px"
                                                    v-show="errors.has('form-3.Vehicle Restriction to time')"
                                                    class="help text-danger"
                                                    >{{ errors.first("form-3.Vehicle Restriction to time") }}</span
                                                    >
                                                </b-input-group>
                                            </div>
                                        </b-form-group>
                                    </div>

                                    <div class="col-md-4">
                                        <b-form-group>
                                            <label><b>WeekOff</b> <span style="color:red;"> *</span></label>
                                            <b-input-group>
                                                <ejs-multiselect id='multiselect' :dataSource='weekoffdestination' placeholder="Select Weekoff" mode="CheckBox" v-model="customer.destinationWeekoff" name="destinationWeekoff" v-validate="'required'"
                                                :class="{ input: true, 'is-invalid': errors.has('form-3.destinationWeekoff'),
                                                }"></ejs-multiselect>
                                            </b-input-group>
                                            <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i
                                                    class="fa fa-warning"
                                                    v-show="errors.has('destinationWeekoff')"
                                                ></i>
                                                </span>
                                                <span
                                                style="width:240px"
                                                v-show="errors.has('form-3.destinationWeekoff')"
                                                class="help text-danger"
                                                >{{ errors.first("form-3.destinationWeekoff") }}</span
                                                >
                                            </b-input-group>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-4">
                                        <b-form-group>
                                            <label><b>Destination Mail ID</b> <span style="color:red;"> *</span></label>
                                            <b-input-group>
                                                <b-form-input name="destinationMailId" v-model.trim="customer.destinationMailId" type="email" placeholder="Destination Mail ID" class="italic-placeholder" v-validate="'required|email'"
                                                :class="{ input: true, 'is-invalid': errors.has('form-3.destinationMailId'),
                                                }"></b-form-input>
                                            </b-input-group>
                                            <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i
                                                    class="fa fa-warning"
                                                    v-show="errors.has('destinationMailId')"
                                                ></i>
                                                </span>
                                                <span
                                                style="width:240px"
                                                v-show="errors.has('form-3.destinationMailId')"
                                                class="help text-danger"
                                                >{{ errors.first("form-3.destinationMailId") }}</span
                                                >
                                            </b-input-group>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-4">
                                        <b-form-group>
                                            <label><b>Destination Phone no.</b> <span style="color:red;"> *</span></label>
                                            <b-input-group>
                                                <b-form-input name="destinationPhone" v-model.trim="customer.destinationPhone" placeholder="Destination Phone no." class="italic-placeholder" v-validate="'required|digits:10'" maxlength="10"
                                                :class="{ input: true, 'is-invalid': errors.has('form-3.destinationPhone'),
                                                }"></b-form-input>
                                            </b-input-group>
                                            <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i
                                                    class="fa fa-warning"
                                                    v-show="errors.has('destinationPhone')"
                                                ></i>
                                                </span>
                                                <span
                                                style="width:240px"
                                                v-show="errors.has('form-3.destinationPhone')"
                                                class="help text-danger"
                                                >{{ errors.first("form-3.destinationPhone") }}</span
                                                >
                                            </b-input-group>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-4">
                                        <b-form-group>
                                            <label><b>Destination POC</b> <span style="color:red;"> *</span></label>
                                            <b-input-group>
                                                <b-form-input name="destinationPoc" v-model.trim="customer.destinationPoc" placeholder="Destination POC" class="italic-placeholder" v-validate="'required'"
                                                :class="{ input: true, 'is-invalid': errors.has('form-3.destinationPoc'),
                                                }"></b-form-input>
                                            </b-input-group>
                                            <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i
                                                    class="fa fa-warning"
                                                    v-show="errors.has('destinationPoc')"
                                                ></i>
                                                </span>
                                                <span
                                                style="width:240px"
                                                v-show="errors.has('form-3.destinationPoc')"
                                                class="help text-danger"
                                                >{{ errors.first("form-3.destinationPoc") }}</span
                                                >
                                            </b-input-group>
                                        </b-form-group>
                                    </div>  
                                    <div class="col-md-4">
                                        <b-form-group>
                                            <label><b>Destination Lat and Long</b> <span style="color:red;"> *</span></label>
                                            <div @mouseenter="showMessage()" @mouseleave="hideMessage()">
                                                <b-form-input name="destinationLatLong"    
                                                placeholder="Select Destination Lat and Long" @focus="hideMessage()" @input="showMessage()" @blur="hideMessage()"  v-model.trim="customer.destinationLatLong" v-validate="'required'"
                                                :class="{ input: true, 'is-invalid': errors.has('form-3.destinationLatLong'),
                                                }"></b-form-input>
                                            </div>
                                            <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i
                                                    class="fa fa-warning"
                                                    v-show="errors.has('destinationLatLong')"
                                                ></i>
                                                </span>
                                                <span
                                                style="width:240px"
                                                v-show="errors.has('form-3.destinationLatLong')"
                                                class="help text-danger"
                                                >{{ errors.first("form-3.destinationLatLong") }}</span
                                                >
                                            </b-input-group>
                                            <h6 v-if="showMsg"><pre style="color: rgb(245 51 50); font-size: 11px;">Lat/Long like this format 18.5172010,73.85191348</pre></h6>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-4">
                                        <b-form-group>
                                            <b>IS Active <span style="color: red;">*</span></b>
                                            <b-form-select v-model="customer.destinationselectedstatus" :options="optionsactive" class="mt-2" name="status" v-validate="'required'"
                                            :class="{ input: true, 'is-invalid': errors.has('form-3.status'),
                                            }"></b-form-select>
                                            <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i
                                                    class="fa fa-warning"
                                                    v-show="errors.has('status')"
                                                ></i>
                                                </span>
                                                <span
                                                style="width:240px"
                                                v-show="errors.has('form-3.status')"
                                                class="help text-danger"
                                                >{{ errors.first("form-3.status") }}</span
                                                >
                                            </b-input-group>
                                        </b-form-group>
                                    </div>

                                    <div class="col-md-4">
                                        <b-form-group>
                                            <label><b>Appointment Day</b> 
                                                <!-- <span style="color:red;"> *</span> -->
                                            </label>
                                            <b-input-group>
                                                <ejs-multiselect id='multiselect' :dataSource='weekappointmentday' placeholder="Select Appointment Day" mode="CheckBox" v-model="customer.appointmentday" name="Appointment Day"></ejs-multiselect>
                                            </b-input-group>
                                            <!-- v-validate="'required'"
                                                :class="{ input: true, 'is-invalid': errors.has('form-3.Appointment Day'),
                                                }"
                                            <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i
                                                    class="fa fa-warning"
                                                    v-show="errors.has('Appointment Day')"
                                                ></i>
                                                </span>
                                                <span
                                                style="width:240px"
                                                v-show="errors.has('form-3.Appointment Day')"
                                                class="help text-danger"
                                                >{{ errors.first("form-3.Appointment Day") }}</span
                                                >
                                            </b-input-group> -->
                                        </b-form-group>
                                    </div>

                                    <!-- <div class="col-md-4">
                                        <b-form-group>
                                            <b>Appointment Date/Time Slot <span style="color: red;">*</span></b>
                                            <b-row>
                                                <b-col md="10">
                                                    <b-row>
                                                        <b-col sm="12">
                                                            <input v-model="selectedDate" class="form-control mt-2 mb-2" type="date" id="date" name="date" @input="handleDateChange"> 
                                                        </b-col> 
                                                        <br> 
                                                        <b-col sm="6">
                                                            <input v-model="startTime" class="form-control" type="time" id="startTime" @input="handleTimeChange">
                                                        </b-col>
                                                        <b-col sm="6">
                                                            <input v-model="endTime" class="form-control" type="time" id="endTime" @input="handleTimeChange">
                                                        </b-col>
                                                    </b-row>  
                                                </b-col>
                                                <b-col md="2" class="p-0">
                                                    <b-button @click="handleOkButtonClick($event,selectedDates)" variant="primary" class="mt-2" size="sm">ADD</b-button>
                                                </b-col>
                                            </b-row>
                                            <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i
                                                    class="fa fa-warning"
                                                    v-show="errors.has('Date Time')"
                                                ></i>
                                                </span>
                                                <span
                                                style="width:240px"
                                                v-show="errors.has('form-3.Date Time')"
                                                class="help text-danger"
                                                >{{ errors.first("form-3.Date Time") }}</span
                                                >
                                            </b-input-group>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-6" v-if="selectedDates.length">
                                        <b-card style="
                                        height: 200px;">
                                        <h6>Added Appointment Date :-</h6>
                                            <span  v-for="(dates,index) in selectedDates" :key="index" >{{dates.appointment_date}} {{dates.time_slot_start}} {{ dates.time_slot_end }} &nbsp;<b-button variant="danger" size="sm" @click="deletedate(index)">x</b-button> &nbsp;&nbsp;</span>
                                        </b-card>
                                    </div> -->
                                    
                                    <div class="col-md-12 mt-2 text-right">
                                        <b-button variant="primary" type="submit" class="mr-2"><i class="fa fa-dot-circle-o"></i> Add</b-button>
                                        <b-button variant="danger" @click="clear()" class="mr-2"><i class="fa fa-ban"></i> Clear</b-button>
                                    </div>
                                        
                                </div>
                            </b-form>
                        </div>
                    </div>

                    <div v-if="search_destination">
                        <div>
                            <h4>Search Destination</h4>
                            <hr>
                            <div class="row mt-3">
                                <div class="col-md-4">
                                    <b-form-group>
                                        <label><b>Destination Name</b></label>
                                        <b-input-group>
                                            <b-form-input type="text" name="destinationName" v-model.trim="destinationName" placeholder="Destination Name" class="italic-placeholder"></b-form-input>
                                        </b-input-group>
                                    </b-form-group>
                                </div>
                                 <div class="col-md-4">
                                    <b-form-group>
                                        <label><b>Destination City</b></label>
                                        <b-input-group>
                                            <b-form-input name="destinationCity" v-validate="'alpha_spaces'" v-model.trim="destinationCity" placeholder="Destination City" class="italic-placeholder"></b-form-input>
                                        </b-input-group>
                                    </b-form-group>
                                </div>
                                <div class="col-md-4">
                                    <b-form-group>
                                        <label><b>Destination Pincode</b></label>
                                        <b-input-group>
                                            <b-form-input type="text" name="destinationPincode" v-model.trim="destinationPincode" placeholder="Pincode" v-validate="'digits:6'" pattern=".{6,6}" class="italic-placeholder" maxlength="6"></b-form-input>
                                        </b-input-group>
                                    </b-form-group>
                                </div>
                                 <div class="col-md-4">
                                    <b-form-group>
                                        <label><b>Destination ID</b></label>
                                        <b-input-group>
                                            <b-form-input type="text" name="destinationId" v-model.trim="destinationId" placeholder="Destination ID" class="italic-placeholder"></b-form-input>
                                        </b-input-group>
                                    </b-form-group>
                                </div>
                                 <div class="col-md-4">
                                    <b-form-group>
                                        <label><b>Destination Type</b></label>
                                        <b-input-group>
                                            <b-form-input name="destinationtype" v-model.trim="destinationtype" placeholder="Destination Type" class="italic-placeholder"></b-form-input>
                                        </b-input-group>
                                    </b-form-group>
                                </div>
                                <div class="col-md-12 text-right" >
                                    <b-button variant="primary" @click="destinationmasterlist(pageNum)" class="mr-2"><i class="fa fa-dot-circle-o"></i> search</b-button>
                                    <b-button variant="danger" @click="clear()" class="mr-2"><i class="fa fa-ban"></i> Clear</b-button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br><br>

                    <div>
                        <b-row>
                            <b-col md="12" class="text-right">
                                <b text-variant="red">Total Records :<span style="color: red;"> {{totalRows}}</span></b>
                            </b-col>
                            <b-col md="12">
                                <b-table show-empty responsive :items="items" :fields="fields" :current-page="currentPage"  :per-page="perPage"  :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"    @filtered="onFiltered"    :outlined="outlined" :busy="isBusy">
                                    <div slot="table-busy" class="text-center text-danger my-2">
                                        <b-spinner class="align-middle"></b-spinner>
                                        <strong>Loading...</strong>
                                    </div>  
                                    <template slot="sno" slot-scope="row">
                                        <div>
                                            {{ row.index+1 }}
                                        </div>
                                    </template>
                                    <template slot="createddate" slot-scope="row">
                                        <div>
                                            {{ row.item.createddate | ConvertTime12hour() }}
                                        </div>
                                    </template>
                                    <template slot="lastmodifieddate" slot-scope="row">
                                        <div>
                                            {{ row.item.lastmodifieddate | ConvertTime12hour() }}
                                        </div>
                                    </template>
                                    <template slot="isactive" slot-scope="row">
                                        <span class="badge badge-success" v-if="row.item.isactive=='1'" style="cursor: pointer;"  @click="activeInactive(row.item)">
                                            Active
                                        </span>
                                        <span class="badge badge-success" v-if="row.item.isactive=='Yes'" style="cursor: pointer;"  @click="activeInactive(row.item)">
                                            Active
                                        </span>
                                        <span class="badge badge-danger"  v-if="row.item.isactive=='0'" style="cursor: pointer;"  @click="activeInactive(row.item)">In Active</span>
                                        <span class="badge badge-danger"  v-if="row.item.isactive=='No'" style="cursor: pointer;"  @click="activeInactive(row.item)">In Active</span>
                                    </template>
                                    <template slot="dest_latlong" slot-scope="row">
                                        {{ row.item.dest_latlong!=null&&row.item.dest_latlong!=""?row.item.dest_latlong.replace(/[\(\)']+/g,''):"" }}
                                    </template>
                                    <template slot="action" slot-scope="row">
                                        <div>
                                            <b-button size="sm" @click="editdestinationmodelopen(row.item,row.index)"><i class="fa fa-pencil" ></i></b-button>
                                        </div>
                                    </template>
                                </b-table>
                            </b-col>
                        </b-row>
                    </div>

                    <b-row>
                        <b-col sm="12" class="text-right">
                          <br>
                               <p style="margin-top: 5px;"> <b>Total Records :<span style="color:red;"> {{totalRows}}</span></b> </p>
                        </b-col>
                        <b-col md="12" class="my-1" >
                            <paginate 
                            v-model="pageNum"
                                :page-count="noofpages"
                                :page-range="20"
                                :margin-pages="2"
                                :click-handler="clickCallback"
                                :prev-text="'Prev'"
                                :next-text="'Next'"
                                :container-class="'pagination'"
                                :page-class="'page-item'">
                            </paginate>
                        </b-col>   
                    </b-row> 

                    <!-- //model -->
                    <b-modal title="Update Destination Master" v-model="showeditmodel" @ok="showeditmodel=false" hide-footer size="xl">
                        <b-card>
                            <b-form
                            @submit.prevent="validateForm1('form-1')" data-vv-scope="form-1">
                                <div class="row mt-3">
                                    <div id="overlaymodel" >
                                        <div class="modelloader"></div>
                                      </div>
                                    <div class="col-md-4">
                                        <b-form-group>
                                            <label><b>Client Name</b> <span style="color:red;"> *</span></label>
                                            <v-select name="destination Client Name" v-model="user.destinationClientName" :options="clientname" placeholder="select destination Client Name"  v-validate="'required'"
                                                :class="{ input: true, 'is-invalid': errors.has('form-1.destination Client Name'),
                                                }"></v-select>
                                            <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i
                                                    class="fa fa-warning"
                                                    v-show="errors.has('destination Client Name')"
                                                ></i>
                                                </span>
                                                <span
                                                style="width:240px"
                                                v-show="errors.has('form-1.destination Client Name')"
                                                class="help text-danger"
                                                >{{ errors.first("form-1.destination Client Name") }}</span
                                                >
                                            </b-input-group>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-4">
                                        <b-form-group>
                                            <label><b>Destination Type</b> <span style="color:red;"> *</span></label>
                                            <v-select  name="destination type" v-model="user.destination_type" :options="desti_type" v-validate="'required'"
                                            :class="{ input: true, 'is-invalid': errors.has('form-1.destination type'),
                                            }" placeholder="select destination type"></v-select>
                                            <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i
                                                    class="fa fa-warning"
                                                    v-show="errors.has('destination type')"
                                                ></i>
                                                </span>
                                                <span
                                                style="width:240px"
                                                v-show="errors.has('form-1.destination type')"
                                                class="help text-danger"
                                                >{{ errors.first("form-1.destination type") }}</span
                                                >
                                            </b-input-group>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-4">
                                        <b-form-group>
                                            <label><b>Destination Name</b> <span style="color:red;"> *</span></label>
                                            <b-input-group>
                                                <b-form-input type="text" name="destination Name" v-model.trim="user.destinationName" placeholder="Destination Name" class="italic-placeholder" v-validate="'required'"
                                                :class="{ input: true, 'is-invalid': errors.has('form-1.destination Name'),
                                                }"></b-form-input>
                                            </b-input-group>
                                            <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i
                                                    class="fa fa-warning"
                                                    v-show="errors.has('destination Name')"
                                                ></i>
                                                </span>
                                                <span
                                                style="width:240px"
                                                v-show="errors.has('form-1.destination Name')"
                                                class="help text-danger"
                                                >{{ errors.first("form-1.destination Name") }}</span
                                                >
                                            </b-input-group>
                                        </b-form-group>
                                    </div>
                                    <!-- ~~~~~~~~~~~~~~ -->
                                    <div class="col-md-4">
                                        <b-form-group>
                                            <label><b>Destination ID</b> <span style="color:red;"> *</span></label>
                                            <b-input-group>
                                                <b-form-input type="text" name="destination Id" v-model.trim="user.destinationId" placeholder="Destination ID" class="italic-placeholder" v-validate="'required'"
                                                :class="{ input: true, 'is-invalid': errors.has('form-1.destination Id'),
                                                }"></b-form-input>
                                            </b-input-group>
                                            <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i
                                                    class="fa fa-warning"
                                                    v-show="errors.has('destination Id')"
                                                ></i>
                                                </span>
                                                <span
                                                style="width:240px"
                                                v-show="errors.has('form-1.destination Id')"
                                                class="help text-danger"
                                                >{{ errors.first("form-1.destination Id") }}</span
                                                >
                                            </b-input-group>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-4">
                                        <b-form-group>
                                            <label><b>Country Name</b> <span style="color:red;"> *</span></label>
                                            <v-select  name="Destination Country" v-model="user.destinationCountry" :options="country" @input="editselectcountry('country',user.destinationCountry)" v-validate="'required'"
                                            :class="{ input: true, 'is-invalid': errors.has('form-1.Destination Country'),
                                            }" placeholder="select destination type"></v-select>
                                            <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i
                                                    class="fa fa-warning"
                                                    v-show="errors.has('Destination Country')"
                                                ></i>
                                                </span>
                                                <span
                                                style="width:240px"
                                                v-show="errors.has('form-1.Destination Country')"
                                                class="help text-danger"
                                                >{{ errors.first("form-1.Destination Country") }}</span
                                                >
                                            </b-input-group>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-4">
                                        <b-form-group>
                                            <label><b>State Name</b> <span style="color:red;"> *</span></label>
                                            <v-select  name="Destination State"  placeholder=" Select Destination State" v-model="user.destinationState" @input="editselectstate('city',user.destinationCountry,user.destinationState)" :disabled="!user.destinationCountry"  :options="StateList" v-validate="'required'"
                                            :class="{ input: true, 'is-invalid': errors.has('form-1.Destination State'),
                                            }"></v-select>
                                            <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i
                                                    class="fa fa-warning"
                                                    v-show="errors.has('Destination State')"
                                                ></i>
                                                </span>
                                                <span
                                                style="width:240px"
                                                v-show="errors.has('form-1.Destination State')"
                                                class="help text-danger"
                                                >{{ errors.first("form-1.Destination State") }}</span
                                                >
                                            </b-input-group>
                                        </b-form-group>
                                    </div>
                    
                                    <!-- ~~~~~~~~~~~~~~ -->        
                                    <div class="col-md-4">
                                        <b-form-group>
                                            <label><b>City Name</b> <span style="color:red;"> *</span></label>
                                            <v-select name="Destination City"       @input="editselectcity('pincode',user.destinationCountry,user.destinationState,user.destinationCity)" :disabled="!user.destinationState" placeholder="Select City Name" :options="CityList"  v-model="user.destinationCity" v-validate="'required'"
                                            :class="{ input: true, 'is-invalid': errors.has('form-1.Destination City'),
                                            }"></v-select>
                                            <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i
                                                    class="fa fa-warning"
                                                    v-show="errors.has('Destination City')"
                                                ></i>
                                                </span>
                                                <span
                                                style="width:240px"
                                                v-show="errors.has('form-1.Destination City')"
                                                class="help text-danger"
                                                >{{ errors.first("form-1.Destination City") }}</span
                                                >
                                            </b-input-group>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-4">
                                        <b-form-group>
                                            <label><b>Destination Pincode</b> <span style="color:red;"> *</span></label>
                                            <v-select  name="Destination Pincode"       :disabled="!user.destinationCity" :options="PincodeList" v-model="user.destinationPincode" placeholder=" Select Destination Pincode" class="italic-placeholder" v-validate="'required'"
                                            :class="{ input: true, 'is-invalid': errors.has('form-1.Destination Pincode'),
                                            }"></v-select>
                                            <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i
                                                    class="fa fa-warning"
                                                    v-show="errors.has('Destination Pincode')"
                                                ></i>
                                                </span>
                                                <span
                                                style="width:240px"
                                                v-show="errors.has('form-1.Destination Pincode')"
                                                class="help text-danger"
                                                >{{ errors.first("form-1.Destination Pincode") }}</span
                                                >
                                            </b-input-group>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-4">
                                        <b-form-group>
                                            <label><b>Destination Address</b> <span style="color:red;"> *</span></label>
                                            <b-input-group>
                                                <b-form-input type="text" name="destinationAddress" v-model.trim="user.destinationAddress" placeholder="Destination Address" class="italic-placeholder" v-validate="'required'"
                                                :class="{ input: true, 'is-invalid': errors.has('form-1.destinationAddress'),
                                                }"></b-form-input>
                                            </b-input-group>
                                            <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i
                                                    class="fa fa-warning"
                                                    v-show="errors.has('destinationAddress')"
                                                ></i>
                                                </span>
                                                <span
                                                style="width:240px"
                                                v-show="errors.has('form-1.destinationAddress')"
                                                class="help text-danger"
                                                >{{ errors.first("form-1.destinationAddress") }}</span
                                                >
                                            </b-input-group>
                                        </b-form-group>
                                    </div>
                                    <!-- ~~~~~~~~~~~~~~ -->        
                                    <div class="col-md-4">
                                        <b-form-group>
                                            <label><b>Select Constraint</b> <span style="color:red;"> *</span></label>
                                            <ejs-multiselect :dataSource='constrainlist' placeholder="Select Constraint" :fields='fields1' v-model="user.destinationconstraint_id" 
                                            @change="handleconstraintChange('0',$event)"
                                            name="Constraint" v-validate="'required'"
                                            :class="{ input: true, 'is-invalid': errors.has('form-1.Constraint'),
                                            }"></ejs-multiselect>
                                            <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i
                                                    class="fa fa-warning"
                                                    v-show="errors.has('Constraint')"
                                                ></i>
                                                </span>
                                                <span
                                                style="width:240px"
                                                v-show="errors.has('form-1.Constraint')"
                                                class="help text-danger"
                                                >{{ errors.first("form-1.Constraint") }}</span
                                                >
                                            </b-input-group>
                                        </b-form-group>
                                    </div>

                                    <div class="col-md-4" v-if="constraintName === 'Vehicle Size'" v-for="constraintName in usercheckconstraintnames" :key="constraintName">
                                        <!-- <b-form-group>
                                            <label><b>Restricted Vehicle Size</b> <span style="color:red;"> *</span></label>
                                            <v-select :options="restrictvehicledata" v-model="user.vehicle_size" placeholder="Select Restricted Vehicle Size"  name="Restricted Vehicle Size" v-validate="'required'"
                                            :class="{ input: true, 'is-invalid': errors.has('form-1.Restricted Vehicle Size'),
                                            }"></v-select>
                                            <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i
                                                    class="fa fa-warning"
                                                    v-show="errors.has('Restricted Vehicle Size')"
                                                ></i>
                                                </span>
                                                <span
                                                style="width:240px"
                                                v-show="errors.has('form-1.Restricted Vehicle Size')"
                                                class="help text-danger"
                                                >{{ errors.first("form-1.Restricted Vehicle Size") }}</span
                                                >
                                            </b-input-group>
                                        </b-form-group> -->
                                        
                                        <b-form-group>
                                            <label><b>Restricted Vehicle Size</b> <span style="color:red;"> *</span></label>
                                            <ejs-multiselect :dataSource='restrictvehicledata' placeholder="Select Restricted Vehicle Size" v-model="user.vehicle_size"
                                            name="Restricted Vehicle Size" v-validate="'required'"
                                            :class="{ input: true, 'is-invalid': errors.has('form-1.Restricted Vehicle Size'),
                                            }"></ejs-multiselect>
                                            <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i
                                                    class="fa fa-warning"
                                                    v-show="errors.has('Restricted Vehicle Size')"
                                                ></i>
                                                </span>
                                                <span
                                                style="width:240px"
                                                v-show="errors.has('form-1.Restricted Vehicle Size')"
                                                class="help text-danger"
                                                >{{ errors.first("form-1.Restricted Vehicle Size") }}</span
                                                >
                                            </b-input-group>
                                        </b-form-group>
                                    </div>

                                    <div class="col-md-4" v-if="constraintName === 'Fuel Type'" v-for="constraintName in usercheckconstraintnames" :key="constraintName">
                                        <!-- <b-form-group>
                                            <label><b>Restricted Vehicle Fuel Type</b> <span style="color:red;"> *</span></label>
                                            <v-select :options="restrictvehicletype" v-model="user.fuel_type" placeholder="Select Restricted Vehicle Fuel Type"  name="Restricted Vehicle Fuel Type" v-validate="'required'"
                                            :class="{ input: true, 'is-invalid': errors.has('form-1.Restricted Vehicle Fuel Type'),
                                            }"></v-select>
                                            <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i
                                                    class="fa fa-warning"
                                                    v-show="errors.has('Restricted Vehicle Fuel Type')"
                                                ></i>
                                                </span>
                                                <span
                                                style="width:240px"
                                                v-show="errors.has('form-1.Restricted Vehicle Fuel Type')"
                                                class="help text-danger"
                                                >{{ errors.first("form-1.Restricted Vehicle Fuel Type") }}</span
                                                >
                                            </b-input-group>
                                        </b-form-group> -->
                                        <b-form-group>
                                            <label><b>Restricted Vehicle Fuel Type</b> <span style="color:red;"> *</span></label>
                                            <ejs-multiselect :dataSource='restrictvehicletype' placeholder="Select Restricted Vehicle Fuel Type" v-model="user.fuel_type"
                                            name="Restricted Vehicle Fuel Type" v-validate="'required'"
                                            :class="{ input: true, 'is-invalid': errors.has('form-1.Restricted Vehicle Fuel Type'),
                                            }"></ejs-multiselect>
                                            <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i
                                                    class="fa fa-warning"
                                                    v-show="errors.has('Restricted Vehicle Fuel Type')"
                                                ></i>
                                                </span>
                                                <span
                                                style="width:240px"
                                                v-show="errors.has('form-1.Restricted Vehicle Fuel Type')"
                                                class="help text-danger"
                                                >{{ errors.first("form-1.Restricted Vehicle Fuel Type") }}</span
                                                >
                                            </b-input-group>
                                        </b-form-group>
                                    </div>

                                    <div class="col-md-4" v-if="constraintName === 'Vehicle Restriction Time'" v-for="constraintName in usercheckconstraintnames" :key="constraintName">
                                        <b-form-group>
                                            <!-- @input="editFormatTime" -->
                                            <label><b>Vehicle Restriction time</b> <span style="color:red;"> *</span></label>
                                            <div class="input-group">
                                                <b>From : </b>
                                                <input v-model="user.vehicle_restriction_time" class="form-control" type="time" id="startTime" name="Vehicle Restriction from time" v-validate="'required'"
                                                :class="{ input: true, 'is-invalid': errors.has('form-1.Vehicle Restriction from time'),
                                                }">
                                                <b-input-group class="mb-3">
                                                    <span class="icon has-text-warning">
                                                    <i
                                                        class="fa fa-warning"
                                                        v-show="errors.has('Vehicle Restriction from time')"
                                                    ></i>
                                                    </span>
                                                    <span
                                                    style="width:240px"
                                                    v-show="errors.has('form-1.Vehicle Restriction from time')"
                                                    class="help text-danger"
                                                    >{{ errors.first("form-1.Vehicle Restriction from time") }}</span
                                                    >
                                                </b-input-group>
                                            </div>
                                        </b-form-group>
                                    </div>

                                    <div class="col-md-4" v-if="constraintName === 'Vehicle Restriction Time'" v-for="constraintName in usercheckconstraintnames" :key="constraintName">
                                        <b-form-group>
                                            <!-- @input="editFormatTime" -->
                                            <label><b>Vehicle Restriction time</b> <span style="color:red;"> *</span></label>
                                            <div class="input-group">
                                                <b>To : </b>
                                                <input v-model="user.vehicle_restriction_to_time" class="form-control" type="time" name="Vehicle Restriction to time" v-validate="'required'"
                                                :class="{ input: true, 'is-invalid': errors.has('form-1.Vehicle Restriction to time'),
                                                }">
                                                <b-input-group class="mb-3">
                                                    <span class="icon has-text-warning">
                                                    <i
                                                        class="fa fa-warning"
                                                        v-show="errors.has('Vehicle Restriction to time')"
                                                    ></i>
                                                    </span>
                                                    <span
                                                    style="width:240px"
                                                    v-show="errors.has('form-1.Vehicle Restriction to time')"
                                                    class="help text-danger"
                                                    >{{ errors.first("form-1.Vehicle Restriction to time") }}</span
                                                    >
                                                </b-input-group>
                                            </div>
                                        </b-form-group>
                                    </div>

                                    <div class="col-md-4">
                                        <b-form-group>
                                            <label><b>WeekOff</b> <span style="color:red;"> *</span></label>
                                            <b-input-group>
                                                <ejs-multiselect id='multiselect' :dataSource='weekoffdestination' placeholder="Select Weekoff" v-model="user.destinationWeekoff" name="destinationWeekoff" 
                                                @change="handleSelectionChange" v-validate="'required'"
                                                :class="{ input: true, 'is-invalid': errors.has('form-1.destinationWeekoff'),
                                                }"></ejs-multiselect>

                                            </b-input-group>
                                            <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i
                                                    class="fa fa-warning"
                                                    v-show="errors.has('destinationWeekoff')"
                                                ></i>
                                                </span>
                                                <span
                                                style="width:240px"
                                                v-show="errors.has('form-1.destinationWeekoff')"
                                                class="help text-danger"
                                                >{{ errors.first("form-1.destinationWeekoff") }}</span
                                                >
                                            </b-input-group>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-4">
                                        <b-form-group>
                                            <label><b>Destination Mail ID</b> <span style="color:red;"> *</span></label>
                                            <b-input-group>
                                                <b-form-input name="destinationMailId" v-model.trim="user.destinationMailId" placeholder="Destination Mail ID" type="email" class="italic-placeholder" v-validate="'required|email'"
                                                :class="{ input: true, 'is-invalid': errors.has('form-1.destinationMailId'),
                                                }"></b-form-input>
                                            </b-input-group>
                                            <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i
                                                    class="fa fa-warning"
                                                    v-show="errors.has('destinationMailId')"
                                                ></i>
                                                </span>
                                                <span
                                                style="width:240px"
                                                v-show="errors.has('form-1.destinationMailId')"
                                                class="help text-danger"
                                                >{{ errors.first("form-1.destinationMailId") }}</span
                                                >
                                            </b-input-group>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-4">
                                        <b-form-group>
                                            <label><b>Destination Phone no.</b> <span style="color:red;"> *</span></label>
                                            <b-input-group>
                                                <b-form-input name="destinationPhone" v-model.trim="user.destinationPhone" placeholder="Destination Phone no." class="italic-placeholder" v-validate="'required|digits:10'" maxlength="10"
                                                :class="{ input: true, 'is-invalid': errors.has('form-1.destinationPhone'),
                                                }"></b-form-input>
                                            </b-input-group>
                                            <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i
                                                    class="fa fa-warning"
                                                    v-show="errors.has('destinationPhone')"
                                                ></i>
                                                </span>
                                                <span
                                                style="width:240px"
                                                v-show="errors.has('form-1.destinationPhone')"
                                                class="help text-danger"
                                                >{{ errors.first("form-1.destinationPhone") }}</span
                                                >
                                            </b-input-group>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-4">
                                        <b-form-group>
                                            <label><b>Destination POC</b> <span style="color:red;"> *</span></label>
                                            <b-input-group>
                                                <b-form-input name="destinationPoc" v-model.trim="user.destinationPoc" placeholder="Destination POC" class="italic-placeholder" v-validate="'required'"
                                                :class="{ input: true, 'is-invalid': errors.has('form-1.destinationPoc'),
                                                }"></b-form-input>
                                            </b-input-group>
                                            <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i
                                                    class="fa fa-warning"
                                                    v-show="errors.has('destinationPoc')"
                                                ></i>
                                                </span>
                                                <span
                                                style="width:240px"
                                                v-show="errors.has('form-1.destinationPoc')"
                                                class="help text-danger"
                                                >{{ errors.first("form-1.destinationPoc") }}</span
                                                >
                                            </b-input-group>
                                        </b-form-group>
                                    </div>  
                                    <div class="col-md-4">
                                        <b-form-group>
                                            <label><b>Destination Lat and Long</b> <span style="color:red;"> *</span></label>
                                            <div @mouseenter="showMessage()" @mouseleave="hideMessage()">
                                                <b-form-input name="destinationLatLong"   @focus="hideMessage()" @input="showMessage()" @blur="hideMessage()"  
                                                placeholder="Select Origin Lat and Long"   v-model.trim="user.destinationLatLong" v-validate="'required'"
                                                :class="{ input: true, 'is-invalid': errors.has('form-1.destinationLatLong'),
                                                }"></b-form-input>
                                            </div>
                                               
                                            <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i
                                                    class="fa fa-warning"
                                                    v-show="errors.has('destinationLatLong')"
                                                ></i>
                                                </span>
                                                <span
                                                style="width:240px"
                                                v-show="errors.has('form-1.destinationLatLong')"
                                                class="help text-danger"
                                                >{{ errors.first("form-1.destinationLatLong") }}</span
                                                >
                                            </b-input-group>
                                            <div v-if="showMsg"><pre style="color: rgb(245 51 50); font-size: 11px;">Lat/Long like this format 18.51720103,73.85191348</pre></div>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-4">
                                        <b-form-group>
                                            <b>IS Active <span style="color: red;">*</span></b>
                                            <b-form-select v-model="user.destinationselectedstatus" :options="optionsactive" class="mt-2" name="status" v-validate="'required'"
                                            :class="{ input: true, 'is-invalid': errors.has('form-1.status'),
                                            }"></b-form-select>
                                            <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i
                                                    class="fa fa-warning"
                                                    v-show="errors.has('status')"
                                                ></i>
                                                </span>
                                                <span
                                                style="width:240px"
                                                v-show="errors.has('form-1.status')"
                                                class="help text-danger"
                                                >{{ errors.first("form-1.status") }}</span
                                                >
                                            </b-input-group>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-4">
                                        <b-form-group>
                                            <label><b>Appointment Day</b> 
                                                <!-- <span style="color:red;"> *</span> -->
                                            </label>
                                            <b-input-group>
                                                <ejs-multiselect id='multiselect' :dataSource='weekappointmentday' placeholder="Select Appointment Day" v-model="user.appointmentday" name="Appointment Day"></ejs-multiselect>
                                            </b-input-group>
                                            <!-- v-validate="'required'"
                                                :class="{ input: true, 'is-invalid': errors.has('form-1.Appointment Day'),
                                                }" -->
                                            <!-- <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i
                                                    class="fa fa-warning"
                                                    v-show="errors.has('Appointment Day')"
                                                ></i>
                                                </span>
                                                <span
                                                style="width:240px"
                                                v-show="errors.has('form-1.Appointment Day')"
                                                class="help text-danger"
                                                >{{ errors.first("form-1.Appointment Day") }}</span
                                                >
                                            </b-input-group> -->
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-12 mt-4 text-right">
                                        <b-button variant="primary" type="submit" class="mr-2"><i class="fa fa-dot-circle-o"></i> Update</b-button>
                                        <b-button variant="danger" @click="clear()" class="mr-2"><i class="fa fa-ban"></i> Clear</b-button>
                                    </div>
                                        
                                </div>
                            </b-form>
                        </b-card>
                    </b-modal>

                    <b-modal title="Confirmation Box" v-model="toggleInfo" size="md"
                    @ok="toggleInfo = false">
                    <template slot="modal-header" slot-scope="{ close }">
                      <h5>Confirmation Box</h5>
                    </template>
        
                    <template slot="default" slot-scope="{ hide }">
                      <form v-on:submit.prevent="activateInActivateDeliveryAgent()">
                        <div class="modal-background"></div>
                        <div class="modal-card">
                          <section class="modal-card-body">
                            <input
                              type="hidden"
                              v-model="customer.isactive"
                              name="isactive"
                              id="modalIsActiveChk"
                            />
                            <span>Are you sure you want to change the status?</span>
                          </section>
                          <footer>
                            <b-button variant="primary" size="sm" type="submit"
                              >Ok</b-button
                            >
                          </footer>
                        </div>
                      </form>
                    </template>
        
                    <template slot="modal-footer" slot-scope="{ cancel }">
                        <b-button size="sm" variant="danger" @click="toggleInfo = false">
                            Cancel
                        </b-button>
                    </template>
                  </b-modal>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import auth from "@/utils/auth";
export default {
    data() {
        return {
            isBusy : false,
            totalRows :0,
            items :[],
            fields :[
                {key:'destination_id',label:'Destination ID'},
                {key:'destination_name',label:'Destination Name'},
                {key:'group_name',label:'Group Name'}, 
                {key:'destinationgroup_id',label:'Group ID'},
                {key:'destination_pincode',label:'Group Pincode'},
                {key:'destination_city',label:'City'},
                {key:'destination_state',label:'State'},
                {key:'rb_constraint',label:'Constraint'},
                {key:'isactive',label:'Is Active'},
                {key:'dest_latlong',label:'Lat/Long'},
                {key:'total_weekof',label:'WeekOff'},
                {key:'destination_type',label:'Destination Type'},
                {key:'createdby',label:'Created By'},
                {key:'createddate',label:'Created Date'},
                {key:'lastmodifiedby',label:'Updated By'},
                {key:'lastmodifieddate',label:'Updated Date'},
                {key:'action',label:'Edit'},

            ],

            //add destination start
            add_destinationinfo : false,
            customer :{
                destinationconstraint_id :[],
                destinationWeekoff :[],
                destinationselectedstatus:null,
                destination_type:null,
                vehicle_size:[],
                fuel_type:[],
                vehicle_restriction_time: '',
                vehicle_restriction_to_time:'',
                appointmentday:[],
            },
            clientnamelist: [],
            clientname :[],
            desti_type :['Stockist','Distributor','Franchise','Store' ,'Vendor'],
            optionsactive : [ 
                { value: null, text: 'Please select status' },
                { value: 'Yes', text: 'Yes' },
                { value: 'No', text: 'No' },
            ],
            weekoffdestination: ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],
            restrictvehicledata: ['PICKUP','407','14 FT','17 FT','19 FT','20 FT','22 FT','32 FT'],
            restrictvehicletype: ['Petrol','Diesel','CNG','Electric'],
            // vehicle_datetype:'',
            checkconstraintname:'',
            checkconstraintnames: [],
            weekappointmentday : ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],
            //add destination end

            //serach start
            search_destination :false,
            destinationName :'',
            destinationCity :'',
            destinationPincode :'',
            destinationId:'',
            destinationtype:'',
            //search end


            //pagination start
            currentPage: 1,
            perPage:  20,
            sortBy: null,
            sortDesc: false,
            sortDirection: 'asc',
            noofpages:0,
            pageNum:1,
            listingpageno:1,
            //pagination end

            items_ConstraintList :[],
            constrainlist :[],
            fields1 : { text: 'label', value: 'key' },

            //csv
            csvurl:'',

            //edit start
            showeditmodel :false,                                                                   
            user : {
                destinationClientName : '',
                destinationName : '',
                destinationId : '',
                destinationLatLong : '',
                destinationCountry : '',
                destinationState : '',
                destinationCity : '',
                destinationPincode : '',
                destinationAddress : '',
                destinationMailId : '',
                destinationPhone : '',
                destinationPoc : '',
                destinationconstraint_id :[],
                destinationWeekoff :[],
                destinationselectedstatus:null,
                destination_type:null,
                vehicle_restriction_time: '',
                vehicle_restriction_to_time:'',
                appointmentday:[],
                vehicle_size:[],
                fuel_type:[],
            },
            destination_masterid :'',
            showMsg: false,
            usercheckconstraintnames:[],
            // editvehicle_datetype:'',
            //edit end


            // dates
            selectedDates: [],
            select_date :'',
            dateTime: new Date(),
            end: null,
            selectedDateTimes : [],
            selectedDate: '',
            startTime: '',
            endTime: '',
            addAppointmentFlag:false,
            // end dates

            //country
            Obj :{},
            country:["India"],
            item_state :[],
            StateList:[],
            item_city : [],
            CityList : [],
            item_pincode : [],
            PincodeList : [],
            editObj:{},
            addObj:{}
        }
    },
    created() {
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        console.log("YUUUUU", userInfo);
    
        this.allclientlist()
        this.ConstraintList()
        this.destinationmasterlist(this.pageNum)
        this.getStateList('country')
    },
    methods: {

        activeInactive(data){
            console.log("data",data)
            this.$fire({
                text: data.isactive=='Yes'?"Do you want to change the status In Active?":"Do you want to change the status Active?",
                type: "warning",
                showCancelButton: true,
                showConfirmButton: true,
                confirmButtonText: "OK",
                cancelButtonText: "Cancel",
                showLoaderOnConfirm: true 
            }).then((result) => {
                console.log("result", result)
                /* Read more about isConfirmed, isDenied below */
                if (result.value) {
                    document.getElementById("overlay").style.display = "block";
                    var userdata = localStorage.getItem("userData");
                    var userInfo = JSON.parse(userdata);

                    const obj = {
                        id : `${data.id}`,
                        isActive : data.isactive=='Yes'?'No':'Yes',
                        lastmodifiedby :`${userInfo.userfirstname + ' ' + userInfo.userlastname}`,
                    } 
                    this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/updateIsActive`,obj)
                    .then((result) => {
                        console.log("result",result)
                        document.getElementById("overlay").style.display = "none";
                        if (result.body.returnmsg=="Successful") {
                            this.$fire({
                                text: result.body.returnmsg,
                                type: "success",
                                timer: 30000,
                            });
                            this.destinationmasterlist(this.pageNum)
                        }
                        else{
                            this.$fire({
                                text: result.body.returnmsg,
                                type: "error",
                                timer: 30000,
                            });
                        }
                    })
                    .catch((ex) => {
                        console.log("error", ex);
                    });
                } else if (result.dismiss) {
                    this.$fire({
                        text: 'Status Is Not Changes',
                        type: "error",
                        timer: 30000,
                    });
                }
            });
        },

        handleConstrainName(selectedValue) {
            console.log("selectedValue",selectedValue.value)
            this.checkconstraintnames = []; // Reset the array
           if (selectedValue.value.length>0) {
                selectedValue.value.forEach(id => {
                    const constraint = this.constrainlist.find(item => item.key === id);
                    if (constraint) {
                        console.log("constraint.label",constraint.label)
                        this.checkconstraintnames.push(constraint.label);
                    }
                });
                console.log("this.checkconstraintnames",this.checkconstraintnames)
                if(!this.checkconstraintnames.includes('Vehicle Size')){
                    this.customer.vehicle_size = '';
                }
                if(!this.checkconstraintnames.includes('Fuel Type')){
                    this.customer.fuel_type = '';
                }
                if(!this.checkconstraintnames.includes('Vehicle Restriction Time')){
                    this.customer.vehicle_restriction_time = '';
                    this.customer.vehicle_restriction_to_time = '';
                    // this.vehicle_datetype = '';
                }
            }
            else{
                this.checkconstraintname='';
                this.customer.vehicle_size = '';
                this.customer.fuel_type = '';
                this.customer.vehicle_restriction_time = '';
                this.customer.vehicle_restriction_to_time = '';
                // this.vehicle_datetype = '';
            }
        },

        showMessage() {
            console.log("++++++++++++++++++++++++++")
            this.showMsg = true;
        },

        hideMessage() {
            console.log("--------------------")
            this.showMsg = false;
        },
        
        // formatTime(event) {
        //     const inputTime = event.target.value;
        //     const [hours, minutes] = inputTime.split(":");
        //     let formattedTime = "";

        //     // Convert hours to 12-hour format
        //     let am_pm = "AM";
        //     let formattedHours = parseInt(hours, 10);
        //     if (formattedHours >= 12) {
        //         am_pm = "PM";
        //         if (formattedHours > 12) {
        //         formattedHours -= 12;
        //         }
        //     }
        //     if (formattedHours === 0) {
        //         formattedHours = 12;
        //     }

        //     // Add leading zero if necessary
        //     formattedTime += formattedHours < 10 ? "0" + formattedHours : formattedHours;
        //     formattedTime += ":" + minutes;
        //     formattedTime += " " + am_pm;

        //     this.customer.vehicle_restriction_time = formattedTime;
        //     this.vehicle_datetype = this.customer.vehicle_restriction_time.split(' ')[0];

        // },

        handleDateChange(date) {
            // console.log("Data",this.selectedDate);
            
        },

        handleTimeChange(time){
         
        },

        deletedate(index){
            this.selectedDates.splice(index,1)
        },

        handleOkButtonClick(event,selectedDates) {
            if(this.selectedDate !=''){
                if(this.startTime !='' && this.endTime !=''){
                if(this.startTime<=this.endTime){
                    // console.log("this.selectedDate",this.selectedDate,this.startTime,this.endTime)
                    this.selectedDates.push({
                        "appointment_date": this.selectedDate,
                        "time_slot_start": this.startTime,
                        "time_slot_end": this.endTime
                        })
                        this.selectedDate='';
                        this.startTime='';
                        this.endTime='';
                    // console.log("this.selectedDates@@@@@@@@@@@",this.selectedDates)
                }else{
                    this.$fire({
                        text: `Start Time ${this.startTime} should be smaller than End Time ${this.endTime}`,
                        type: "error",
                        timer: 30000,
                    });
                }
               
            }else{
                this.$fire({
                        text: `Please Select both Start and End time`,
                        type: "warning",
                        timer: 30000,
                    });
            }
            }else{
                this.$fire({
                        text: `Please Select Appointment Date`,
                        type: "warning",
                        timer: 30000,
                    }); 
            }
           
            // console.log("this.selectedDates",selectedDates)
            // // console.log('Click event:', event.type);
            // this.selectedDateTimes=selectedDates
            // if(this.selectedDateTimes.length>0){
                
            //     this.addAppointmentFlag=true
            // }else{
            //     this.addAppointmentFlag=true
            // }
           
            // Perform actions when the "OK" button is clicked
            // For example, you can push the selected date and time into an array
            // const selectedDateTime = this.end;
            // // Validate selectedDateTime as needed
            // if (selectedDateTime) {
            //     this.selectedDateTimes.push(selectedDateTime);
            //     console.log('Selected Date and Time Array:', this.selectedDateTimes);
            // }
        },

        downloadcsv(){
            this.search_destination=false;
            this.add_destinationinfo=false;
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            this.csvurl=`${CONSTANTS.MIGRATION_API_URL}/getdestinationmasterListCsv?sysusermasterid=`+userInfo.sysusermasterid+`&&`+`destination_name=`+this.destinationName+`&&`+`destination_city=`+this.destinationCity+`&&`+`destination_pincode=`+this.destinationPincode+`&&`+`destination_id=`+this.destinationId+`&&`+`destination_type=`+this.destinationtype
        
        },

        adddestination(){
            this.clear()
            this.add_destinationinfo=!this.add_destinationinfo;
            this.search_destination=false;
        },

        search(){
            this.clear()
            this.search_destination=!this.search_destination;
            this.add_destinationinfo=false
        },

        clear(){
            console.log("------>>>>>>>>..",this.currentPage)
            this.noofpages=0;
            this.listingpageno=1;
            this.pageNum=1;
            this.totalRows = 0;
            this.checkconstraintnames=[];
            // this.vehicle_datetype = '';
            // this.editvehicle_datetype ='';
            this.customer ={
                destinationCountry : '',
                destinationState : '',
                destinationCity : '',
                destinationPincode : '',
                destinationconstraint_id :[],
                destinationWeekoff :[],
                destinationselectedstatus:null,
                destination_type:null,
                vehicle_size:[],
                fuel_type:[],
            }
            this.destinationName ='';
            this.destinationCity ='';
            this.destinationPincode ='';
            this.destinationId ='';
            this.destinationtype ='';
            this.user={
                destinationClientName : '',
                destinationName : '',
                destinationId : '',
                destinationLatLong : '',
                destinationCountry : '',
                destinationState : '',
                destinationCity : '',
                destinationPincode : '',
                destinationAddress : '',
                destinationMailId : '',
                destinationPhone : '',
                destinationPoc : '',
                destinationconstraint_id :[],
                destinationWeekoff :[],
                destinationselectedstatus:null,
                destination_type:null,
                appointmentday:[],
                vehicle_size:[],
                fuel_type:[],
            }
            this.item_state = [];
                this.StateList = [];
                this.item_city = [];
                this.CityList = [];
                this.item_pincode = [];
                this.PincodeList = [];
                this.clientnamelist =[];
                    this.clientname =[];
            this.destinationmasterlist(this.pageNum)
            this.getStateList('country')
            this.allclientlist()   
        },

        allclientlist(){
            this.clientnamelist =[];
            this.clientname =[]
            this.customer.destinationClientName ='';
            const Obj = {}
            // return false;
            this.$http
            .post(`${CONSTANTS.MIGRATION_API_URL}/getallclientlist`,Obj)
            .then((result) => {
                console.log("result",result)
                if (result.body.returnmsg === "Successful") {
                    this.clientnamelist = result.body.returnvalue;

                    this.clientnamelist.forEach(value => {
                        var client = {
                            key:value.clientmasterid,
                            label:value.clientname
                        }
                        this.clientname.push(client)
                        if (value.clientmasterid==27 && value.clientname=="Firstcry") {
                            this.customer.destinationClientName = client;
                        }
                    });
                } else {
                    this.clientnamelist =[];
                    this.clientname =[];
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },

          // add start

        validateForm(scope) {
            // console.log("------------",this.customer)
            this.$validator.validateAll(scope).then((result) => {
                if (result) {
                    this.adddestinationmasterinfo();
                }
            });
        },

        adddestinationmasterinfo(){
            
            document.getElementById("overlay").style.display = "block"; 
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            if(this.customer.vehicle_restriction_time > this.customer.vehicle_restriction_to_time){
                this.$fire({
                    text: "Vehicle Restriction From Time should be smaller than Vehicle Restriction To Time",
                    type: "error",
                    timer: 30000,
                });
                document.getElementById("overlay").style.display = "none";
                return;
            }
            
            // const Obj = {
            //     sysusermasterid : userInfo.sysusermasterid,
            //     client_id : this.customer.destinationClientName==null?'':this.customer.destinationClientName.key,
            //     destination_type : this.customer.destination_type,
            //     destination_name : this.customer.destinationName,
            //     destination_id : this.customer.destinationId,
            //     dest_latlong : this.customer.destinationLatLong,
            //     destination_country : this.customer.destinationCountry,
            //     destination_state : this.customer.destinationState,
            //     destination_city : this.customer.destinationCity,
            //     destination_pincode : this.customer.destinationPincode,
            //     destination_address : this.customer.destinationAddress,
            //     constraint_id : this.customer.destinationconstraint_id,
            //     dest_weekoof : this.customer.destinationWeekoff,
            //     destination_emailid : this.customer.destinationMailId,
            //     destination_phone : this.customer.destinationPhone,
            //     destination_poc : this.customer.destinationPoc,
            //     createdby :`${userInfo.userfirstname + ' ' + userInfo.userlastname}`,
            //     isactive : this.customer.destinationselectedstatus,
            //     vehicle_size:this.customer.vehicle_size,
            //     fuel_type: this.customer.fuel_type,
            //     vehicle_restriction_time:`${this.customer.vehicle_restriction_time}`,
            //     appointment_day:this.customer.appointmentday,
            // }
            if(this.customer.vehicle_size!='' && this.customer.fuel_type!=''){
                
                this.addObj = {
                sysusermasterid : userInfo.sysusermasterid,
                client_id : this.customer.destinationClientName==null?'':this.customer.destinationClientName.key,
                destination_type : this.customer.destination_type,
                destination_name : this.customer.destinationName,
                destination_id : this.customer.destinationId,
                dest_latlong : this.customer.destinationLatLong,
                destination_country : this.customer.destinationCountry,
                destination_state : this.customer.destinationState,
                destination_city : this.customer.destinationCity,
                destination_pincode : this.customer.destinationPincode,
                destination_address : this.customer.destinationAddress,
                constraint_id : this.customer.destinationconstraint_id,
                dest_weekoof : this.customer.destinationWeekoff,
                destination_emailid : this.customer.destinationMailId,
                destination_phone : this.customer.destinationPhone,
                destination_poc : this.customer.destinationPoc,
                createdby :`${userInfo.userfirstname + ' ' + userInfo.userlastname}`,
                isactive : this.customer.destinationselectedstatus,
                vehicle_size:this.customer.vehicle_size,
                fuel_type: this.customer.fuel_type,
                vehicle_restriction_time:`${this.customer.vehicle_restriction_time}`,
                vehicle_restriction_to_time:`${this.customer.vehicle_restriction_to_time}`,
                appointment_day:this.customer.appointmentday,
            }
            }else if(this.customer.vehicle_size!=''){
              
                this.addObj = {
                sysusermasterid : userInfo.sysusermasterid,
                client_id : this.customer.destinationClientName==null?'':this.customer.destinationClientName.key,
                destination_type : this.customer.destination_type,
                destination_name : this.customer.destinationName,
                destination_id : this.customer.destinationId,
                dest_latlong : this.customer.destinationLatLong,
                destination_country : this.customer.destinationCountry,
                destination_state : this.customer.destinationState,
                destination_city : this.customer.destinationCity,
                destination_pincode : this.customer.destinationPincode,
                destination_address : this.customer.destinationAddress,
                constraint_id : this.customer.destinationconstraint_id,
                dest_weekoof : this.customer.destinationWeekoff,
                destination_emailid : this.customer.destinationMailId,
                destination_phone : this.customer.destinationPhone,
                destination_poc : this.customer.destinationPoc,
                createdby :`${userInfo.userfirstname + ' ' + userInfo.userlastname}`,
                isactive : this.customer.destinationselectedstatus,
                vehicle_size:this.customer.vehicle_size,
                // fuel_type: this.customer.fuel_type,
                vehicle_restriction_time:`${this.customer.vehicle_restriction_time}`,
                vehicle_restriction_to_time:`${this.customer.vehicle_restriction_to_time}`,
                appointment_day:this.customer.appointmentday,
            }
           }else if(this.customer.fuel_type!=''){
        
            this.addObj = {
                sysusermasterid : userInfo.sysusermasterid,
                client_id : this.customer.destinationClientName==null?'':this.customer.destinationClientName.key,
                destination_type : this.customer.destination_type,
                destination_name : this.customer.destinationName,
                destination_id : this.customer.destinationId,
                dest_latlong : this.customer.destinationLatLong,
                destination_country : this.customer.destinationCountry,
                destination_state : this.customer.destinationState,
                destination_city : this.customer.destinationCity,
                destination_pincode : this.customer.destinationPincode,
                destination_address : this.customer.destinationAddress,
                constraint_id : this.customer.destinationconstraint_id,
                dest_weekoof : this.customer.destinationWeekoff,
                destination_emailid : this.customer.destinationMailId,
                destination_phone : this.customer.destinationPhone,
                destination_poc : this.customer.destinationPoc,
                createdby :`${userInfo.userfirstname + ' ' + userInfo.userlastname}`,
                isactive : this.customer.destinationselectedstatus,
                // vehicle_size:this.customer.vehicle_size,
                fuel_type: this.customer.fuel_type,
                vehicle_restriction_time:`${this.customer.vehicle_restriction_time}`,
                vehicle_restriction_to_time:`${this.customer.vehicle_restriction_to_time}`,
                appointment_day:this.customer.appointmentday,
            }
            }else{
                
                this.addObj = {
                sysusermasterid : userInfo.sysusermasterid,
                client_id : this.customer.destinationClientName==null?'':this.customer.destinationClientName.key,
                destination_type : this.customer.destination_type,
                destination_name : this.customer.destinationName,
                destination_id : this.customer.destinationId,
                dest_latlong : this.customer.destinationLatLong,
                destination_country : this.customer.destinationCountry,
                destination_state : this.customer.destinationState,
                destination_city : this.customer.destinationCity,
                destination_pincode : this.customer.destinationPincode,
                destination_address : this.customer.destinationAddress,
                constraint_id : this.customer.destinationconstraint_id,
                dest_weekoof : this.customer.destinationWeekoff,
                destination_emailid : this.customer.destinationMailId,
                destination_phone : this.customer.destinationPhone,
                destination_poc : this.customer.destinationPoc,
                createdby :`${userInfo.userfirstname + ' ' + userInfo.userlastname}`,
                isactive : this.customer.destinationselectedstatus,
                // vehicle_size:this.customer.vehicle_size,
                // fuel_type: this.customer.fuel_type,
                vehicle_restriction_time:`${this.customer.vehicle_restriction_time}`,
                vehicle_restriction_to_time:`${this.customer.vehicle_restriction_to_time}`,
                appointment_day:this.customer.appointmentday,
            }
            }
           console.log("this.addObj-------------->",this.addObj)
            this.$http
            .post(`${CONSTANTS.MIGRATION_API_URL}/addrbdestinationmaster`,this.addObj)
            .then((result) => {
                // console.log(result);
                document.getElementById("overlay").style.display = "none";
                if (result.body.returnmsg === "Successful") {
                this.$fire({
                    text: result.body.returnvalue,
                    type: "success",
                    timer: 30000,
                });
                this.add_destinationinfo = false;
                this.destinationmasterlist(this.pageNum)
                this.customer = {};
                this.selectedDates =[]
                this.clientnamelist =[];
                this.clientname =[];
                this.clear();
                } else {
                    this.$fire({
                        text: result.body.returnvalue,
                        type: "error",
                        timer: 30000,
                    });
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },

        // add end
        clickCallback (pageNum){
            this.listingpageno = pageNum;
            this.destinationmasterlist(pageNum);
        },

        destinationmasterlist(pageNum){
            this.items =[];
            this.totalRows =0;
            this.isBusy=true;
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            const Obj = {
                // sysusermasterid :`${userInfo.sysusermasterid}`,
                page_no : pageNum,
                destination_name :  this.destinationName.trim(),
                destination_city :  this.destinationCity.trim(),
                destination_pincode :  this.destinationPincode.trim(),
                destination_id : this.destinationId.trim(),
                destination_type: this.destinationtype.trim(),
            }
            // return false;
            this.$http
            .post(`${CONSTANTS.MIGRATION_API_URL}/getdestinationmasterList`,Obj)
            .then((result) => {
                this.isBusy=false;
                if (result.body.returnmsg === "Successful") {
                    this.items = result.body.returnvalue;
                    this.totalRows = result.body.totalcount;
                    this.noofpages=parseInt(this.totalRows)/20;
                    this.noofpages=Math.ceil( this.noofpages);
            
                } else {
                    this.items =[];
                    this.totalRows =0;
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },

        ConstraintList(){
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            
            const Obj = {}
            // return false;
            this.$http
            .post(`${CONSTANTS.MIGRATION_API_URL}/getconstraintmasterList`,Obj)
            .then((result) => {
                if (result.body.returnmsg === "Successful") {
                    this.items_ConstraintList = result.body.returnvalue;
                    this.items_ConstraintList.forEach(value => {
                        var constrainlist={
                            key:`${value.constraint_id}`,
                            label:value.rb_constraint
                        }
                        this.constrainlist.push(constrainlist)
                    });
                } else {
                    this.items_ConstraintList =[];
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },

        // edit

        // editFormatTime(event) {
        //     const inputTime = event.target.value;
        //     const [hours, minutes] = inputTime.split(":");
        //     let formattedTime = "";

        //     // Convert hours to 12-hour format
        //     let am_pm = "AM";
        //     let formattedHours = parseInt(hours, 10);
        //     if (formattedHours >= 12) {
        //         am_pm = "PM";
        //         if (formattedHours > 12) {
        //         formattedHours -= 12;
        //         }
        //     }
        //     if (formattedHours === 0) {
        //         formattedHours = 12;
        //     }

        //     // Add leading zero if necessary
        //     formattedTime += formattedHours < 10 ? "0" + formattedHours : formattedHours;
        //     formattedTime += ":" + minutes;
        //     formattedTime += " " + am_pm;

        //     this.user.vehicle_restriction_time = formattedTime;
        //     this.editvehicle_datetype = this.user.vehicle_restriction_time.split(' ')[0];

        // },

        editdestinationmodelopen(value){
            console.log(value)
           this.user = {};
           this.user={
                destinationClientName : '',
                destinationName : '',
                destinationId : '',
                destinationLatLong : '',
                destinationCountry : '',
                destinationState : '',
                destinationCity : '',
                destinationPincode : '',
                destinationAddress : '',
                destinationMailId : '',
                destinationPhone : '',
                destinationPoc : '',
                destinationconstraint_id :[],
                destinationWeekoff :[],
                destinationselectedstatus:null,
                destination_type:null,
                appointmentday:[],
                vehicle_size:[],
                fuel_type:[],
            }
            // this.editvehicle_datetype ='';
            this.add_destinationinfo=false;
            this.search_destination=false;
            this.user.destinationClientName = value.clientname;
            if ( this.user.destinationClientName) {
                this.handleClientNameChange( this.user.destinationClientName)
            }
            this.user.destination_type = value.destination_type;
            this.user.destinationName = value.destination_name;
            this.user.destinationId = value.destination_id;
            if (value.dest_latlong) {
                this.user.destinationLatLong = value.dest_latlong.replace(/[\(\)']+/g,'');
            }

            this.user.destinationCountry = value.destination_country;
            if (value.destination_country!=null && value.destination_country != undefined) {
                this.editselectcountry('country',this.user.destinationCountry)
            }
            this.user.destinationState = value.destination_state;
            if (value.destination_state!=null && value.destination_state != undefined) {
                this.editselectstate('city',this.user.destinationCountry,this.user.destinationState)
            }
            this.user.destinationCity = value.destination_city;
            if (value.destination_city!=null && value.destination_city!=undefined) {
                this.editselectcity('pincode',this.user.destinationCountry,this.user.destinationState,this.user.destinationCity)
            }
            this.user.destinationPincode = value.destination_pincode;
            this.user.destinationAddress = value.destination_address;
          
            if (value.constraint_id) {
                var destext = value.constraint_id.split(',')
                this.user.destinationconstraint_id = destext;
                this.handleconstraintChange('1',this.user.destinationconstraint_id)
            }

            if (value.dest_weekoof) {
                var text = value.dest_weekoof.split(',')
                this.user.destinationWeekoff= text;
            }
            this.user.destinationMailId = value.destination_emailid;
            this.user.destinationPhone = value.destination_phone;
            this.user.destinationPoc = value.destination_poc;
            this.user.destinationselectedstatus = value.isactive;
            this.destination_masterid = value.id;

            if (value.vehicle_size) {
                var vehicle_size = value.vehicle_size.split(',')
                this.user.vehicle_size = vehicle_size;
            }

            if (value.fuel_type) {
                var fuel_type = value.fuel_type.split(',')
                this.user.fuel_type = fuel_type;
            }
            // this.user.vehicle_size = value.vehicle_size;
            // this.user.fuel_type = value.fuel_type;
            
            if (value.vehicle_restriction_time=='undefined' || value.vehicle_restriction_time=='null' || value.vehicle_restriction_time==undefined || value.vehicle_restriction_time==null || value.vehicle_restriction_time=="") {
                console.log("ppppppppppp")
            }
            else{
                this.user.vehicle_restriction_time = value.vehicle_restriction_time;
                // this.editvehicle_datetype = value.vehicle_restriction_time.split(' ')[0]
            }
            if (value.vehicle_restriction_to_time=='undefined' || value.vehicle_restriction_to_time=='null' || value.vehicle_restriction_to_time==undefined || value.vehicle_restriction_to_time==null || value.vehicle_restriction_to_time=="") {
                console.log("ppppppppppp")
            }
            else{
                this.user.vehicle_restriction_to_time = value.vehicle_restriction_to_time;
                // this.editvehicle_datetype = value.vehicle_restriction_time.split(' ')[0]
            }
            if (value.appointment_day=='undefined' || value.appointment_day=='null' || value.appointment_day==undefined || value.appointment_day==null || value.appointment_day=="") {
               console.log("00000000000")
            }
            else{
                var text = value.appointment_day.split(',')
                this.user.appointmentday = text;
            }
            this.showeditmodel=!this.showeditmodel
        },

        handleconstraintChange: function(value,selectedValue){
            if (value=='1') {
                this.usercheckconstraintnames = []; // Reset the array
                if (selectedValue.length>0) {
                    selectedValue.forEach(id => {
                        const constraint = this.constrainlist.find(item => item.key === id);
                        if (constraint) {
                            this.usercheckconstraintnames.push(constraint.label);
                        }

                    });
                    if(!this.usercheckconstraintnames.includes('Vehicle Size')){
                        this.user.vehicle_size = '';
                    }
                    if(!this.usercheckconstraintnames.includes('Fuel Type')){
                        this.user.fuel_type = '';
                    }
                    if(!this.usercheckconstraintnames.includes('Vehicle Restriction Time')){
                        this.user.vehicle_restriction_time = '';
                        this.user.vehicle_restriction_to_time = '';
                        // this.editvehicle_datetype = '';
                    }
                }
                else{
                    this.usercheckconstraintnames='';
                    this.user.vehicle_size = '';
                    this.user.fuel_type = '';
                    this.user.vehicle_restriction_time = '';
                    this.user.vehicle_restriction_to_time = '';
                    // this.editvehicle_datetype = '';
                }
            }
            else{
                console.log("selectedValue.value",selectedValue.value)
                this.usercheckconstraintnames = []; // Reset the array
                if (selectedValue.value.length>0) {
                    selectedValue.value.forEach(id => {
                        const constraint = this.constrainlist.find(item => item.key === id);
                        if (constraint) {
                            console.log("constraint.label",constraint.label)
                            this.usercheckconstraintnames.push(constraint.label);
                        }
                    });
                    if(!this.usercheckconstraintnames.includes('Vehicle Size')){
                        this.user.vehicle_size = '';
                    }
                    if(!this.usercheckconstraintnames.includes('Fuel Type')){
                        this.user.fuel_type = '';
                    }
                    if(!this.usercheckconstraintnames.includes('Vehicle Restriction Time')){
                        this.user.vehicle_restriction_time = '';
                        this.user.vehicle_restriction_to_time = '';
                        // this.editvehicle_datetype = '';
                    }
                }
                else{
                    this.usercheckconstraintnames='';
                    this.user.vehicle_size = '';
                    this.user.fuel_type = '';
                    this.user.vehicle_restriction_time = '';
                    this.user.vehicle_restriction_to_time = '';
                    // this.editvehicle_datetype = '';
                }
            }

        },

        handleSelectionChange: function(event) {
            console.log('Selected week changed:', event.value);
        },

        handleClientNameChange(selectedValue) {
            const selectedKeyObject = this.findKeyObjectByLabel(selectedValue);
            // Do something with the selected key object
            console.log('Selected key object:', selectedKeyObject);
            this.user.destinationClientName = selectedKeyObject;
        },

        findKeyObjectByLabel(label) {
            return this.clientname.find(item => item.label === label) || null;
        },

        validateForm1(scope1){
            console.log("----------",this.user)
            this.$validator.validateAll(scope1).then((result1) => {
                console.log("--------------",result1 )
                if (result1) {
                    this.updatedestinationmaster();
                }
            });
        },

        updatedestinationmaster(){
            document.getElementById("overlaymodel").style.display = "block";
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            if(this.user.vehicle_restriction_time > this.user.vehicle_restriction_to_time){
                this.$fire({
                    text: "Vehicle Restriction From Time should be smaller than Vehicle Restriction To Time",
                    type: "error",
                    timer: 30000,
                });
                document.getElementById("overlaymodel").style.display = "none";
                return;
            }
            // console.log("this.user.vehicle_size----------->",this.user.vehicle_size,this.user.fuel_type)
            if(this.user.vehicle_size!='' && this.user.fuel_type!=''){
                
                this.editObj = {
                sysusermasterid : userInfo.sysusermasterid,
                destination_masterid : this.destination_masterid,
                client_id : this.user.destinationClientName==null?'':this.user.destinationClientName.key,
                destination_type : this.user.destination_type,
                destination_name : this.user.destinationName,
                destination_id : this.user.destinationId,
                dest_latlong : this.user.destinationLatLong,
                destination_country : this.user.destinationCountry,
                destination_state : this.user.destinationState,
                destination_city : this.user.destinationCity,
                destination_pincode : this.user.destinationPincode,
                destination_address : this.user.destinationAddress,
                constraint_id : this.user.destinationconstraint_id,
                dest_weekoof : this.user.destinationWeekoff,
                destination_emailid : this.user.destinationMailId,
                destination_phone : this.user.destinationPhone,
                destination_poc : this.user.destinationPoc,
                lastmodifiedby :`${userInfo.userfirstname + ' ' + userInfo.userlastname}`,
                isactive : this.user.destinationselectedstatus,
                vehicle_size:this.user.vehicle_size,
                fuel_type:this.user.fuel_type,
                vehicle_restriction_time:`${this.user.vehicle_restriction_time}`,
                vehicle_restriction_to_time :`${this.user.vehicle_restriction_to_time}`,
                appointment_day:this.user.appointmentday,
            }
            }else if(this.user.vehicle_size!=''){
                
                this.editObj = {
                sysusermasterid : userInfo.sysusermasterid,
                destination_masterid : this.destination_masterid,
                client_id : this.user.destinationClientName==null?'':this.user.destinationClientName.key,
                destination_type : this.user.destination_type,
                destination_name : this.user.destinationName,
                destination_id : this.user.destinationId,
                dest_latlong : this.user.destinationLatLong,
                destination_country : this.user.destinationCountry,
                destination_state : this.user.destinationState,
                destination_city : this.user.destinationCity,
                destination_pincode : this.user.destinationPincode,
                destination_address : this.user.destinationAddress,
                constraint_id : this.user.destinationconstraint_id,
                dest_weekoof : this.user.destinationWeekoff,
                destination_emailid : this.user.destinationMailId,
                destination_phone : this.user.destinationPhone,
                destination_poc : this.user.destinationPoc,
                lastmodifiedby :`${userInfo.userfirstname + ' ' + userInfo.userlastname}`,
                isactive : this.user.destinationselectedstatus,
                vehicle_size:this.user.vehicle_size,
                
                vehicle_restriction_time:`${this.user.vehicle_restriction_time}`,
                vehicle_restriction_to_time:`${this.user.vehicle_restriction_to_time}`,
                appointment_day:this.user.appointmentday,
            }
           }else if(this.user.fuel_type!=''){
            
            this.editObj = {
                sysusermasterid : userInfo.sysusermasterid,
                destination_masterid : this.destination_masterid,
                client_id : this.user.destinationClientName==null?'':this.user.destinationClientName.key,
                destination_type : this.user.destination_type,
                destination_name : this.user.destinationName,
                destination_id : this.user.destinationId,
                dest_latlong : this.user.destinationLatLong,
                destination_country : this.user.destinationCountry,
                destination_state : this.user.destinationState,
                destination_city : this.user.destinationCity,
                destination_pincode : this.user.destinationPincode,
                destination_address : this.user.destinationAddress,
                constraint_id : this.user.destinationconstraint_id,
                dest_weekoof : this.user.destinationWeekoff,
                destination_emailid : this.user.destinationMailId,
                destination_phone : this.user.destinationPhone,
                destination_poc : this.user.destinationPoc,
                lastmodifiedby :`${userInfo.userfirstname + ' ' + userInfo.userlastname}`,
                isactive : this.user.destinationselectedstatus,
                fuel_type:this.user.fuel_type, 
                vehicle_restriction_time:`${this.user.vehicle_restriction_time}`,
                vehicle_restriction_to_time:`${this.user.vehicle_restriction_to_time}`,
                appointment_day:this.user.appointmentday,
            }
            }else{
                this.editObj = {
                sysusermasterid : userInfo.sysusermasterid,
                destination_masterid : this.destination_masterid,
                client_id : this.user.destinationClientName==null?'':this.user.destinationClientName.key,
                destination_type : this.user.destination_type,
                destination_name : this.user.destinationName,
                destination_id : this.user.destinationId,
                dest_latlong : this.user.destinationLatLong,
                destination_country : this.user.destinationCountry,
                destination_state : this.user.destinationState,
                destination_city : this.user.destinationCity,
                destination_pincode : this.user.destinationPincode,
                destination_address : this.user.destinationAddress,
                constraint_id : this.user.destinationconstraint_id,
                dest_weekoof : this.user.destinationWeekoff,
                destination_emailid : this.user.destinationMailId,
                destination_phone : this.user.destinationPhone,
                destination_poc : this.user.destinationPoc,
                lastmodifiedby :`${userInfo.userfirstname + ' ' + userInfo.userlastname}`,
                isactive : this.user.destinationselectedstatus,
                vehicle_restriction_time:`${this.user.vehicle_restriction_time}`,
                vehicle_restriction_to_time:`${this.user.vehicle_restriction_to_time}`,
                appointment_day:this.user.appointmentday,
            }
            }
             
          console.log("TESSSSSSSSSSSSS",this.editObj);
            // return false;
            this.$http
            .post(`${CONSTANTS.MIGRATION_API_URL}/editrbdestinationmaster`,this.editObj)
            .then((result) => {
                console.log(result);
                document.getElementById("overlaymodel").style.display = "none";
                if (result.body.returnmsg === "Successful") {
                this.$fire({
                    text: result.body.returnvalue,
                    type: "success",
                    timer: 30000,
                });
                this.showeditmodel = false;
                this.destinationmasterlist(this.pageNum)
                this.user = {};
                this.clientnamelist =[];
                this.clientname =[];
                this.clear();
                } else {
                    this.$fire({
                        text: result.body.returnvalue,
                        type: "error",
                        timer: 30000,
                    });
                }
            }).catch((ex) => {
                console.log("error", ex);
            });
        },


        // country state city pincode 
        // add start
        selectcountry(value,data){
            if (value=='country') {
                this.getStateList('country')
            }
            // if (value=='state') {
            //     this.getStateList('state',country)
            // }
            if (data==null) {
                this.item_state = [];
                this.StateList = [];
                this.item_city = [];
                this.CityList = [];
                this.item_pincode = [];
                this.PincodeList = [];
                this.customer.destinationCountry='';
                this.customer.destinationState='';
                this.customer.destinationCity='';
                this.customer.destinationPincode='';
            }
        },
        
        selectstate(value,country,state){
            if (value=='city') {
                this.item_city = [];
                this.CityList = [];
                this.item_pincode = [];
                this.PincodeList = [];
                this.customer.destinationCity='';
                this.customer.destinationPincode='';
                this.getStateList('city',country,state)
            }
            if (state==null) {
                this.item_state = [];
                this.StateList = [];
                this.item_city = [];
                this.CityList = [];
                this.item_pincode = [];
                this.PincodeList = [];
                this.customer.destinationState='';
                this.customer.destinationCity='';
                this.customer.destinationPincode='';
                this.getStateList('country')
            }
        },

        selectcity(value,country,state,city){
            if (value=='pincode') {
                this.item_pincode = [];
                this.PincodeList = [];
                this.customer.destinationPincode='';
                this.getStateList('pincode',country,state,city)
            }
            if (city==null) {
                this.item_city = [];
                this.CityList = [];
                this.item_pincode = [];
                this.PincodeList = [];
                this.customer.destinationCity='';
                this.customer.destinationPincode='';
                this.getStateList('city',country,state)
            }
        },

        // add end

        // edit start
        editselectcountry(value,data){
            if (value=='country') {
                this.getStateList('country')
            }
            // if (value=='state') {
            //     this.getStateList('state',country)
            // }
            if (data==null) {
                this.item_state = [];
                this.StateList = [];
                this.item_city = [];
                this.CityList = [];
                this.item_pincode = [];
                this.PincodeList = [];
                this.user.destinationCountry='';
                this.user.destinationState='';
                this.user.destinationCity='';
                this.user.destinationPincode='';
            }
        },
        
        editselectstate(value,country,state){
            if (value=='city') {
                this.item_city = [];
                this.CityList = [];
                this.item_pincode = [];
                this.PincodeList = [];
                this.user.destinationCity='';
                this.user.destinationPincode='';
                this.getStateList('city',country,state)
            }
            if (state==null) {
                this.item_state = [];
                this.StateList = [];
                this.item_city = [];
                this.CityList = [];
                this.item_pincode = [];
                this.PincodeList = [];
                this.user.destinationState='';
                this.user.destinationCity='';
                this.user.destinationPincode='';
                this.getStateList('country')
            }
        },

        editselectcity(value,country,state,city){
            if (value=='pincode') {
                this.item_pincode = [];
                this.PincodeList = [];
                this.user.destinationPincode='';
                this.user.destinationPincode=null;
                this.getStateList('pincode',country,state,city)
            }
            if (city==null) {
                this.item_city = [];
                this.CityList = [];
                this.item_pincode = [];
                this.PincodeList = [];
                this.user.destinationCity='';
                this.user.destinationPincode='';
                this.getStateList('city',country,state)
            }
        },

        // edit end

        // editgetStateList(value,country,state,city){
        //     console.log(country)
        //     var userdata = localStorage.getItem("userData");
        //     var userInfo = JSON.parse(userdata);
            
        //     if (value=='country') {
        //         this.Obj = {
        //             country : "",
        //             state : "",
        //             city : "",
        //             pincode : ""
        //         }
        //     }

        //     // if (value=='state') {
        //     //     this.Obj = {
        //     //         country : country,
        //     //         state : "",
        //     //         city : "",
        //     //         pincode : ""
        //     //     }
        //     // }

        //     if (value=='city') {
        //         this.Obj = {
        //             country : "",
        //             state : state,
        //             city : "",
        //             pincode : ""
        //         }
        //     }

        //     if (value=='pincode') {
        //         this.Obj = {
        //             country : "",
        //             state : state,
        //             city : city,
        //             pincode : ""
        //         }
        //     }

        //     // return false;
        //     this.$http
        //     .post(`${CONSTANTS.MIGRATION_API_URL}/getStateCityPincodes`,this.Obj)
        //     .then((result) => {
        //         console.log("result",result)
        //         if (result.body.returnmsg === "Successful") {
        //             if (value=='country') {
        //                 this.item_state = result.body.returnvalue;
        //                 this.item_state.forEach(value => {
        //                     this.StateList.push(value.state)
        //                 });
        //             }

        //             if (value=='city') {
        //                 this.item_city = result.body.returnvalue;
        //                 this.item_city.forEach(value => {
        //                     this.CityList.push(value.city)
        //                 });
        //             }

        //             if (value=='pincode') {
        //                 this.item_pincode = result.body.returnvalue;
        //                 this.item_pincode.forEach(value => {
        //                     this.PincodeList.push(value.pincode)
        //                 });
        //             }
        //         } 
        //         // else {
        //         //     this.item_state = [];
        //         //     this.StateList = [];
        //         //     this.item_city = [];
        //         //     this.CityList = [];
        //         //     this.item_pincode = [];
        //         //     this.PincodeList = [];
        //         // }
        //     })
        //     .catch((ex) => {
        //         console.log("error", ex);
        //     });
        // },

        getStateList(value,country,state,city){
            console.log(country)
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            
            if (value=='country') {
                this.Obj = {
                    country : "",
                    state : "",
                    city : "",
                    pincode : ""
                }
            }

            // if (value=='state') {
            //     this.Obj = {
            //         country : country,
            //         state : "",
            //         city : "",
            //         pincode : ""
            //     }
            // }

            if (value=='city') {
                this.Obj = {
                    country : "",
                    state : state,
                    city : "",
                    pincode : ""
                }
            }

            if (value=='pincode') {
                this.Obj = {
                    country : "",
                    state : state,
                    city : city,
                    pincode : ""
                }
            }

            // return false;
            this.$http
            .post(`${CONSTANTS.MIGRATION_API_URL}/getStateCityPincodes`,this.Obj)
            .then((result) => {
                console.log("result",result)
                if (result.body.returnmsg === "Successful") {
                    if (value=='country') {
                        this.item_state = [];
                        this.StateList = [];
                        this.item_city = [];
                        this.CityList = [];
                        this.item_pincode = [];
                        this.PincodeList = [];
                        this.item_state = result.body.returnvalue;
                        this.item_state.forEach(value => {
                            this.StateList.push(value.state)
                        });
                    }

                    if (value=='city') {
                        this.item_city = [];
                        this.CityList = [];
                        this.item_pincode = [];
                        this.PincodeList = [];
                        this.item_city = result.body.returnvalue;
                        this.item_city.forEach(value => {
                            this.CityList.push(value.city)
                        });
                    }

                    if (value=='pincode') {
                        this.item_pincode = [];
                        this.PincodeList = [];
                        this.item_pincode = result.body.returnvalue;
                        this.item_pincode.forEach(value => {
                            this.PincodeList.push(value.pincode)
                        });
                    }
                } 
                else {
                    this.item_state = [];
                    this.StateList = [];
                    this.item_city = [];
                    this.CityList = [];
                    this.item_pincode = [];
                    this.PincodeList = [];
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },
    },
}
</script>

<!-- <style>
.e-multiselect.e-checkbox .e-multi-select-wrapper{
    border: 1px solid #635151;
}

</style> -->
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>